// extracted by mini-css-extract-plugin
module.exports = {"hr":"styles_hr__7jHjN"};